import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { mapBoardingAchProcessorData } from "mappers/boarding";
import { boardingACHProcessor } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useGetAchProcessorDetailsQuery = (
	applicationId: string,
	achProcessor: string | undefined,
) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["getACHProcessorDetails", applicationId, achProcessor],
		() => boardingACHProcessor.getACHProcessorData(applicationId),
		{
			select(data: { [key: string]: any }) {
				return mapBoardingAchProcessorData(data);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!applicationId && !!achProcessor,
		},
	);

	return queryResult;
};

export default useGetAchProcessorDetailsQuery;
